import {motion,useScroll,useSpring} from 'framer-motion';

function ScrollProgress() {
  const {scrollYProgress} = useScroll();
  const scaleX = useSpring(scrollYProgress, {stiffness: 120, damping: 24});
  return (
    <motion.div
      className="fixed left-0 right-0 top-0 z-50 h-[3px] origin-left bg-brick"
      style={{scaleX}}
      aria-hidden="true"
    />
  );
}

export default ScrollProgress;
